











































































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import AssetCardTaskAssign from './AssetCardTaskAssign.vue';
import AssignmentBoundary from '../hoc/AssignmentBoundary.vue';

import WorkflowStatus from './WorkflowStatus.vue';
import Skeleton from './Skeleton.vue';
import moment from 'moment';
import Slide from '../interfaces/models/Slide';

@Component({
  components: {
    AssetCardTaskAssign,
    WorkflowStatus,
    Skeleton,
    AssignmentBoundary
  },
  filters: {
    fromNow: (value: string) => moment(value).fromNow()
  }
})
export default class AssetCard extends Vue {
  [x: string]: any;
  @Prop({ type: Boolean }) dense?: boolean;
  @Prop({ type: Boolean }) selected?: boolean;
  @Prop({ type: Boolean }) isLoading?: boolean;

  @Prop({ type: Function }) selectFn?: (a: { id: string; key: 'ctrl' | 'shift' }) => void;
  @Prop({ type: Object }) localization?: {
    isInLocalizationMode: boolean;
    status?: { comparing: boolean; localizing: boolean };
  };
  @Prop({ type: Object }) workflow?: { color: string; name: string };
  @Prop({ type: Array }) assignedTo?: { email: string; name: string }[];
  @Prop({ type: Object }) deletion?: {
    willDelete: boolean;
    willDeleteAfter: Date;
    deletedBy: { name: string; email: string };
  };

  @Prop({ type: Object }) imageSet!: { m: string; s?: string };
  @Prop({ type: Object }) tasks?: {
    countByStatus: {
      to_do: number;
      needs_approval: number;
    };
  };
  @Prop({ type: Object }) item!: {
    _id: string;
    name: string;
    externalId: string;
    mandatory: boolean;
    updatedAt: string;
    animationSlides: any[];
    referenceSlides: any[];
    popupSlides: any[];
    references: {
      slide: Slide | null;
      refs: any[];
    };
  };

  @PropSync('mandatory', { type: Boolean }) isSlideMandatory?: boolean;

  imageLoaded = false;

  get loadingState() {
    return this.imageLoaded && !this.isLoading;
  }

  get willDelete() {
    return this.deletion && this.deletion.willDelete;
  }

  get localizationHeaderStyle() {
    const isInLocalizationMode =
      this.localization &&
      (this.localization.isInLocalizationMode ||
        (this.localization.status && this.localization.status.comparing));
    return {
      backgroundColor: this.selected ? '#4561f3' : isInLocalizationMode ? '#ef4d55' : 'white',
      color: isInLocalizationMode || this.selected ? 'white !important' : 'inherit'
    };
  }

  get localizationStatusText() {
    const status = this.localization && this.localization.status;
    if (!status) {
      return '';
    }

    if (status.localizing) {
      return '(Localization Pending)';
    }

    if (status.comparing) {
      return '(Master Update)';
    }

    return '';
  }

  get mandatoryIcon() {
    return this.item.mandatory ? 'mdi-star' : 'mdi-star-outline';
  }

  get chips() {
    const chips = [];
    const { animationSlides, references, popupSlides } = this.item;

    if (animationSlides && animationSlides.length) {
      chips.push({
        icon: 'mdi-gesture-tap',
        text: 'Animated'
      });
    }

    if (references && references.refs && references.refs.length > 0) {
      chips.push({
        icon: 'mdi-book-open-outline',
        text: 'Ref'
      });
    }

    if (popupSlides && popupSlides.length) {
      chips.push({
        icon: 'mdi-watermark',
        text: 'Popup'
      });
    }

    return chips;
  }

  async copy() {
    await this.$clipboard!(this.item.externalId);
    await this.$store.dispatch('alerts/success', 'Copied ID');
  }

  selectMany(id: string) {
    if (id) {
      if (this.selectFn) {
        this.selectFn({ id, key: 'shift' });
      }
      this.$emit('select-asset', { id, key: 'shift' });
    }
  }

  selectOne(id: string) {
    if (id) {
      if (this.selectFn) {
        this.selectFn({ id, key: 'ctrl' });
      }
      this.$emit('select-asset', { id, key: 'ctrl' });
    }
  }
}
